import React, { useState, useEffect } from 'react';
import {
    Form, Button, Spinner
} from 'react-bootstrap';
import {
    faPlus
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SearchHits from './SearchHits';
import JournalOrCreatePopup from './JournalOrCreatePopup';

function PetSearch(props) {

    let [resultRows, setResultRows] = useState(null);
    let [searchTerm, setSearchTerm] = useState('');
    var [isLoading, setIsLoading] = useState(false);
    const [popupShown, setPopupShown] = useState(false);
    const [selection, setSelection] = useState(null);

    const handleSubmit = async (event) => {
        setIsLoading(true);
        event.preventDefault();
        event.stopPropagation();
        const query = `/api/search?q=${searchTerm}`;
        const res = await fetch(query,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                cors: 'cors'
            });
        const resJson = await res.json();
        setResultRows(resJson);
        setIsLoading(false);
    };

    useEffect(() => {
        setResultRows(null);
    }, [props.clearSearch]);

    function getSubmitButton() {
        if (isLoading) {
            return (
                <Button disabled variant="primary">
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        style={{ marginRight: 5 }}
                    />
                    Söker..
                </Button>
            );
        }
        else {
            return (
                <Button disabled={searchTerm.length < 3} type="submit" variant="primary">
                    Sök
                </Button>
            );
        }
    }

    function getSearchField() {
        if (isLoading) {
            return (
                <Form.Control 
                    disabled type="text" 
                    placeholder="Skriv sökord (minst 3 tecken)" />
            );
        }
        else {
            return (
                <Form.Control 
                    onChange={e => setSearchTerm(e.target.value)} 
                    type="text" 
                    placeholder="Skriv sökord (minst 3 tecken)" />
            );
        }
    }

    function onRowSelected(selection) {
        setSelection(selection);
        if (!props.allowCreate && selection?.isPet()) {
            // Skip popup click
            props.onGoToPetJournal(selection);
        }
        else {
            setPopupShown(true);
        }
    }

    function onCreateNewOwner() {
        props.onCreateNewOwner();
    }

    function onGoToPetJournal(selection) {
        setPopupShown(false);
        props.onGoToPetJournal(selection);
    }

    function onCreateNewPet(selection) {
        setPopupShown(false);
        props.onCreateNewPet(selection);
    }

    function onPopupHide() {
        setPopupShown(false);
    }

    function getNewOwnerButton() {
        if (props.allowCreate) {
            return (
                <React.Fragment>
                    <br />
                    <Button variant="success" onClick={onCreateNewOwner}>
                        <FontAwesomeIcon icon={faPlus} style={{ marginRight: 10 }} />
                        Ny kund
                    </Button>
                    <br />
                </React.Fragment>
            )
        }
        else {
            return <React.Fragment />;
        }
    }

    if (!props.shown) {
        return <React.Fragment />;
    }
    else {
        return (
            <React.Fragment>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="formSearch">
                        <Form.Label>Sök djur eller kund</Form.Label>
                        {getSearchField()}
                        <Form.Text className="text-muted">
                            Du kan söka på samma saker som i Agitura Journal
                        </Form.Text>
                        {getSubmitButton()}
                    </Form.Group>
                    {getNewOwnerButton()}
                </Form>
                <JournalOrCreatePopup
                    allowCreate={props.allowCreate} 
                    onGoToPet={onGoToPetJournal} 
                    onCreateNewPet={onCreateNewPet}
                    shown={popupShown}
                    onHide={onPopupHide} 
                    selection={selection} />
                <SearchHits 
                    onRowSelected={onRowSelected} 
                    rows={resultRows}></SearchHits>
            </React.Fragment>
        );
    }

}

export default PetSearch;